import request from "@/utils/request.js";
class Api {
  // 审核下拉列表
  examineList(data) {
    return request({
      url: "/examine/list",
      method: "post",
      data,
    });
  }
  // 审核列表下拉框
  examineSelect(params) {
    return request({
      url: "/examine/select",
      method: "get",
      params,
    });
  }
  // 审核
  examine(data) {
    return request({
      url: "/examine/handle",
      method: "post",
      data,
    });
  }
  // 导出
  examineExport(data) {
    return request({
      url: "/examine/list/export",
      method: "post",
      data,
      responseType: "blob",
    });
  }
}
export default new Api();
